import React from 'react';
import { getCategoryIcon } from '../utils/categoryIcons';

export default function CategoryFilter({ categories, selectedCategory, onCategorySelect, categoriesData }) {
  
  // Debug: Log categories data to console
  console.log('Categories Data:', categoriesData);
  console.log('Product Categories:', categories);
  const getCategoryIconDisplay = (categoryName) => {
    // First try to get icon from database
    if (categoriesData && categoriesData.length > 0) {
      const categoryData = categoriesData.find(cat => 
        cat.categoryName && cat.categoryName.toLowerCase() === categoryName.toLowerCase()
      );
      
      if (categoryData && categoryData.icon) {
        return (
          <img 
            src={categoryData.icon} 
            alt={categoryName}
            className="category-icon-img"
            onError={(e) => {
              // Fallback to emoji if image fails to load
              e.target.style.display = 'none';
              e.target.nextSibling.style.display = 'flex';
            }}
          />
        );
      }
    }
    
    // Fallback to emoji icon
    return <span className="category-icon-emoji">{getCategoryIcon(categoryName)}</span>;
  };

  return (
    <div className="category-filter">
      <h3 className="category-filter-title">Shop by Category</h3>
      <div className="category-buttons">
        <button
          className={`category-btn ${selectedCategory === 'All' ? 'active' : ''}`}
          onClick={() => onCategorySelect('All')}
        >
          <div className="category-icon">
            <span className="category-icon-emoji">🛍️</span>
          </div>
          <span className="category-name">All Products</span>
        </button>
        {categories.map((category) => (
          <button
            key={category}
            className={`category-btn ${selectedCategory === category ? 'active' : ''}`}
            onClick={() => onCategorySelect(category)}
          >
            <div className="category-icon">
              {getCategoryIconDisplay(category)}
              <span className="category-icon-emoji" style={{display: 'none'}}>
                {getCategoryIcon(category)}
              </span>
            </div>
            <span className="category-name">{category}</span>
          </button>
        ))}
      </div>
    </div>
  );
}
